import axios from 'axios';

const BASE_URL = window.API_URL;

const pharmacy = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-device-token': window.device_token,
    'client-type': 'web',
  },
});

pharmacy.interceptors.request.use(function (config) {
  config.baseURL = window.API_URL;
  if(sessionStorage.getItem('authenticated')) {
      config.headers.Authorization = `Bearer ${sessionStorage.getItem('authenticated')}`;
  }
  config.headers['x-device-token'] = sessionStorage.getItem('deviceToken');
  return config;
});

pharmacy.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response.status) {
      window.location.href = '/pharmacy/logout';
    }
    throw error;
  }
);

export default pharmacy;
